import MuiPaper from '@mui/material/Paper';
import type { PaperProps } from './IPaper';
import { styles } from './styles';

const Paper = ({ sx, ...rest }: PaperProps) => (
    <MuiPaper
        sx={[styles.root, ...(Array.isArray(sx) ? sx : [sx])]}
        {...rest}
    />
);

export default Paper;
